import { Component, OnInit, AfterViewInit, Input, Output,EventEmitter } from '@angular/core';
declare var Quill : any
declare var $ : any
@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit, AfterViewInit {

  constructor() { }
  quill;
  @Input() value ;
  @Input() id ="editor-text";
  @Input() config = {height : 100};
  @Output() outputAction: EventEmitter<any> = new EventEmitter<any>();
  ngAfterViewInit()
  {
    this.quill = new Quill('#editor-container' + this.id, 
    {
      modules: {
        formula: true,
        syntax: true,
        toolbar: '#toolbar-container' + this.id,
        imageResize: 
        {
          displaySize: true
        }
      },
      placeholder: 'Compose an epic...',
      theme: 'snow'
    });
    this.quill.on('text-change', (delta, oldDelta, source) =>
    {
      this.value = this.quill.root.innerHTML.trim();
      this.outputAction.emit({action : "text-change"});
    })
    this.quill.on('editor-change', (eventName,args)=>
    {
      this.outputAction.emit({action : "editor-change",eventName,args,editor : this});
    })
    if(this.config)
    {
      if(this.config.height)
      $("#"+this.id).height(this.config.height)
    }
  }
  ngOnInit(): void 
  {
  }
  setHTML(html)
  {
    this.quill.root.innerHTML = html;
  }
  getHTML()
  {
    return this.quill.root.innerHTML.trim();
  }
}
